import { createColumnDate, createColumnInput, createColumnSelect, createColumnTreeSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { putField } from "../../../../utils/form";
import { callRequestDepartment } from "../../storage-location/request/requestor/requestor.section";
import { callDocumentStatus } from "../../storage-location/storage-location/storage-location.section";
import { dateDiffStr, dateFormat } from "../../../../utils/date";
import { callCountry } from "../../haz/request/haz-info/haz-info.section";

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("views.report.docType"),
            dataIndexValue: () => i18n.global.t("views.report.hc"),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false }
        }),
        createColumnInput({ title: () => i18n.global.t("views.report.approveCode"), dataIndex: "approveCode", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("model.hc.refInform"),
            dataIndex: "refInform.approveCode",
            dataIndexValueObject: ({ record }) => {
                return [record.refInform?.approveCode, dateFormat({ text: record.refInform?.createDate, format: "DD/MM/YYYY" })];
            },
            dataIndexValue: ({ record, column }) => {
                return column
                    .dataIndexValueObject({ record })
                    .filter(d => d)
                    .join(" ");
            },
            customRender: ({ record, column }) => {
                return (
                    <>
                        {column.dataIndexValueObject({ record }).map(d => (
                            <div>{d}</div>
                        ))}
                    </>
                );
            },
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.tradeNameTh"),
            dataIndex: "products.refHaz.tradeNameTh",
            dataIndexValueObject: ({ record }) => {
                return record.products.map(d => [d.refInformProduct?.refHaz?.approveCode, d.refInformProduct?.refHaz?.tradeNameTh]);
            },
            dataIndexValue: ({ record, column }) => {
                return column
                    .dataIndexValueObject({ record })
                    .map(d => d.filter(d => d).join(" "))
                    .filter(d => d)
                    .join(", ");
            },
            customRender: ({ record, column }) => {
                return (
                    <>
                        {column
                            .dataIndexValueObject({ record })
                            .map(d => d.filter(d => d).map(d => <div>{d}</div>))
                            .map(d => (
                                <div>{d}</div>
                            ))}
                    </>
                );
            },
            search: { visible: () => false },
            align: "center"
        }),
        createColumnSelect({
            title: () => `${i18n.global.t("views.request.informInfo.country", { text:  i18n.global.t("views.request.informInfo.desc") })}`,
            dataIndex: "refInform.refOriginDestinationCountry.nameTh",
            inputProp: () => ({ list: callCountry, optLabel: "nameTh" }),
            search: { name: "refInform.refOriginDestinationCountry.nameTh" },
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.refUserCompany"),
            dataIndex: "refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refUserCompany?.refPersonType?.key === "1" ? record.refUserCompany?.companyNameTh : record.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnTreeSelect({
            title: () => i18n.global.t("model.request.refDepartment"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({
                list: () => callRequestDepartment({ refRequestDocKey: "23" }),
                renderLabel: ({ item }) => (
                    <div>
                        {item.fullCode} : {item.nameTh}
                    </div>
                ),
                filterWhere: ({ value }) => [
                    { name: "fullCode", operator: "like", value },
                    { logic: "OR", name: "nameTh", operator: "like", value }
                ],
                treeDefaultExpandAll: true
            }),
            search: { visible: () => false, name: "refDepartment.id" },
            width: 200
        }),
        createColumnDate({ title: () => i18n.global.t("views.report.docEffectiveDate"), dataIndex: "effectiveDate", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.haz.expireDate"), dataIndex: "expireDate", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("views.report.docTimeLive"),
            // dataIndexValue: () => "6 เดือน",
            dataIndexValue: ({ record }) => dateDiffStr({ record }), sorter: false,
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callDocumentStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
